import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

// Components
import Routes from "./routes";
import { ToastContainer } from "./components/atoms/toaster";
import ThemeToggle, { useTheme } from "./theme/themeCreate";

// Store
import { addCountryList, addUser } from "./pages/login/redux/loginSlice";

// Services
import adminService from "./services/subAdminsService";
import countryService from "./services/countryService";

// Styles
import "./App.css";

function App() {
  const dispatch = useDispatch();
  const { isDarkTheme, } = useTheme();

  useEffect(() => {
    adminService
      .fetchMyDetails()
      .then((userDetails) => {
        dispatch(addUser(userDetails));
        countryService
          .fetchCountries()
          .then((response) => {
            dispatch(addCountryList(response));
          })
          .catch((err) => console.log(err, "Error"));
      })
      .catch((error) => {
        console.log("Error fetching my details", error);
      });
  }, []);

  return (
    <BrowserRouter>
    
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          newestOnTop
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      <div className={isDarkTheme ? "dark-mode" : "light-mode"}>
        <Routes />
      </div>
    </BrowserRouter>
  );
}

function AppWrapper() {
  return (
    <ThemeToggle>
      <App />
    </ThemeToggle>
  );
}

export default AppWrapper;
